module.exports = __webpack_public_path__ + "img/icon-select-nutritionist.eef5ec65.svg";